import React, { FunctionComponent } from "react";
import { Form, InputNumber } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";
import { getSessionFeedbackNumberRange } from "../sessionFeedbackNumberRange";

// NUMBER — numeric input, with optional min/max from validation.
const NumberInput: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false, formType, legacyId }) => {
  const isSessionFeedback = formType === "SESSION_FEEDBACK";
  const sessionFeedbackRange = getSessionFeedbackNumberRange(legacyId);

  const { minValue, maxValue } = question.validation || {};
  const min = isSessionFeedback ? sessionFeedbackRange.min : minValue;
  const max = isSessionFeedback ? sessionFeedbackRange.max : maxValue;

  const rules: Record<string, unknown>[] = [{ required: question.isRequired, message: "Input is required!" }];
  if (typeof min === "number") rules.push({ type: "number", min, message: `Input must be minimum ${min}.` });
  if (typeof max === "number") rules.push({ type: "number", max, message: `Input must be maximum ${max}.` });

  // SESSION_FEEDBACK: label + criteria description on the left, score input pinned to the top-right.
  if (isSessionFeedback) {
    return (
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0 text-base font-semibold leading-6">
          <FormLabel label={question.label} required={question.isRequired} description={question.description} />
        </div>
        <Form.Item name={question.id} rules={rules} className={styles.disableNumberInput} style={{ marginBottom: 0 }}>
          <InputNumber
            disabled={disabled}
            placeholder={question.placeholder || "Enter"}
            style={{ width: 140 }}
            min={typeof min === "number" ? min : undefined}
            max={typeof max === "number" ? max : undefined}
            addonAfter={`/ ${sessionFeedbackRange.max}`}
          />
        </Form.Item>
      </div>
    );
  }

  return (
    <Form.Item
      name={question.id}
      label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
      rules={rules}
      className={styles.disableNumberInput}
    >
      <InputNumber
        disabled={disabled}
        placeholder={question.placeholder || "Enter"}
        style={{ width: "100%" }}
        min={typeof min === "number" ? min : undefined}
        max={typeof max === "number" ? max : undefined}
      />
    </Form.Item>
  );
};

export default NumberInput;
